/* global PIXI */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Frame from '../../views/Frame.jsx';

import createSprite from '../../../lib/createSprite';
import spritesHelper from '../../../lib/spritesHelper';
import Audio from '../../../lib/audio';
import Utils from '../../../lib/utils';
import scenesData from '../../../data/scenes.json';

import circleOfLife from '../../../flux/circleOfLife';

const CommonAnimations = require('../../../animations/common');

const propTypes = {
    slideshowKey: PropTypes.string,

    backgroundKey: PropTypes.string,
    className: PropTypes.string,
    onSceneChange: PropTypes.func,
    onAnimationReady: PropTypes.func,
    onResumeMessageBox: PropTypes.func,

    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    objs: PropTypes.object.isRequired,
    audioUrls: PropTypes.object.isRequired,

    animationData: PropTypes.object,

    fluxSettings: PropTypes.object,
    portraitKeys: PropTypes.array,
};

const scenesKeys = _.map(_.filter(scenesData, sceneData => (
    !_.get(sceneData, 'index', false)
)), sceneData => (
    sceneData.name
));

const defaultProps = {
    // slideshowKey: 'machineSlideshow',
    backgroundKey: 'kraftBackground',
    layers: [
        {
            backgroundKey: 'pipesCentered',
        },
        {
            backgroundKey: 'darkLinesBackground',
        },
    ],

    className: 'intro-scene-selector',
    sceneKeys: scenesKeys,
    fluxSettings: circleOfLife,
    animationDuration: 0.2,
    audioUrls: {
        flux: ['/audio/28nov/general-liquide-mouv-01.ogg', '/audio/28nov/general-liquide-mouv-01.mp3'],
    },
    portraitKeys: ['agent', 'mom', 'dad', 'charles', 'lady', 'baldGuy'],

    bottomTile: true,
    bottomTileColor: 'beige',
};

const contextTypes = {
    minIntensity: PropTypes.number,
    maxIntensity: PropTypes.number,
    originalWidth: PropTypes.number,
    originalHeight: PropTypes.number,
    cleanTint: PropTypes.number,
    dirtyTints: PropTypes.array,
    events: PropTypes.object,
    scenesCompleted: PropTypes.object,
    store: PropTypes.object,
    language: PropTypes.string,
};

class Machine extends Component {

    constructor(props) {
        super(props);

        this.timeline = null;
        this.sprites = null;
        this.pixiFlux = null;
        this.audios = null;

        this.onTick = this.onTick.bind(this);
        this.onFrameUpdate = this.onFrameUpdate(this);
        this.onStartMessages = this.onStartMessages.bind(this);

        this.build = this.build.bind(this);

        this.play = this.play.bind(this);
        this.pause = this.pause.bind(this);
        this.destroy = this.destroy.bind(this);

        this.animateObjects = this.animateObjects.bind(this);
    }

    componentWillUpdate(nextProps) {
        const animationChanged = this.props.animationData !== nextProps.animationData;
        if (animationChanged) {
            if (this.timeline !== null) {
                this.timeline.seek(nextProps.animationData.time);
                setTimeout(() => {
                    this.timeline.play();
                    setTimeout(() => {
                        this.timeline.pause();
                    }, 300);
                }, 1500);
            }
        }
    }

    build(container, timeline, opts) {
        this.sprites = {
            container,
        };
        this.timeline = timeline;
        this.pixiFlux = opts.pixiFlux;

        const { width } = this.props;
        const sprites = this.sprites;

        // da flux
        const fluxContainer = new PIXI.Container();
        sprites.flux = fluxContainer;
        if (this.pixiFlux) {
            this.pixiFlux.setContainer(fluxContainer, width);
        }
        container.addChild(fluxContainer);

        this.audios = {};
        _.forOwn(this.props.audioUrls, _.bind(function(value, key) {
            this.audios[key] = new Audio(value, {
                loop: key === 'flux',
            });
        }, this));

        this.buildObjects();
        this.animateObjects();
    }

    play() {
        if (this.audios.flux) {
            this.audios.flux.fadeInFast();
        }
        if (this.timeline) {
            this.timeline.seek(0);
            this.timeline.play();
        }
    }

    pause() {
        if (this.audios.flux) {
            this.audios.flux.fadeOutFast();
        }
        if (this.timeline) {
            this.timeline.pause();
        }
    }

    destroy() {
        if (this.audios.flux) {
            this.audios.flux.destroy();
            this.audios.flux = null;
        }

        this.sprites = null;
        this.audios = null;
    }

    buildObjects() {
        const { width, height, objs, slideshowKey, portraitKeys } = this.props;
        const sprites = this.sprites;
        const container = sprites.container;

        var portraitsContainer = new PIXI.Container();
        if (this.props.device === 'phone') {
            portraitsContainer.position.x = 3;
            portraitsContainer.position.y = 10;
            portraitsContainer.scale.x = 0.95;
            portraitsContainer.scale.y = 0.95;
        }

        // PORTRAITS ---------------------------------------
        _.each(portraitKeys, (portraitKey) => {
            sprites[portraitKey+'Portrait'] = this.createAnimatedPortrait(portraitKey);
            portraitsContainer.addChild(sprites[portraitKey+'Portrait']);
        });

        container.addChild(portraitsContainer);

        // const bankerObject = objs[slideshowKey];
        // sprites[slideshowKey] = createSprite(bankerObject);
        // const banker = sprites[slideshowKey];
        //
        // banker.name = slideshowKey;
        // banker.userData = { character: true };
        // Utils.setSizeAndPositionFromRefSize(banker, width, height, bankerObject);
        // container.addChild(banker);

        // CONTAINER MASK
        const containerMask = spritesHelper.createFrameMaskFromSize(width, height);
        container.mask = containerMask;
        container.addChild(containerMask);
    }

    createAnimatedPortrait(key) {
        const props = this.props;
        const objs = props.objs;

        const frameObj = objs[`${key}Frame`];
        const faceObj = objs[`${key}Face`];

        const container = new PIXI.Container();
        const face = createSprite(faceObj);
        const frame = createSprite(frameObj);
        Utils.setSizeAndPositionFromRefSize(frame, props.width, props.height, frameObj);
        Utils.setSizeAndPositionFromRefSize(face, frame.width, frame.height, faceObj);
        face.x += frame.x;
        face.y += frame.y;
        face.name = 'face';
        container.addChild(frame);
        container.addChild(face);

        return container;
    }

    buildObject(container, name) {

    }

    buildParticles() {

    }

    buildAudios() {

    }

    animateObjects() {
        const { slideshowKey, portraitKeys } = this.props;
        const sprites = this.sprites;
        const timeline = this.timeline;

        // movieclips
        // this.movieclipTimeline = timeline.add(CommonAnimations.getMovieclipTimeline(sprites[slideshowKey], {
        //     // fps: 1,
        //     fps: 1 / 6,
        //     delay: 0,
        //     onFrameUpdate: this.onFrameUpdate,
        //     repeat: -1,
        // }), 0);

        _.each(portraitKeys, function(portraitKey, i){
            var portraitFace = sprites[portraitKey+'Portrait'].getChildByName('face');
            timeline.add(CommonAnimations.getMovieclipTimeline(portraitFace, {
                fps: 0.5
            }), i * 0.22);
        });
    }

    isFirstTime() {

    }

    onTick() {

    }

    onFrameUpdate(movieclip) {
        // console.log('frameupdate machine', movieclip);
    }

    onStartMessages() {
        if (this.props.onResumeMessageBox) {
            this.props.onResumeMessageBox();
        }
    }

    render() {
        return (
            <Frame
                onBuild={this.build}
                onPlay={this.play}
                onPause={this.pause}
                onDestroy={this.destroy}
                onTick={this.onTick}
                {...this.props}
            />
        );
    }
}

Machine.propTypes = propTypes;
Machine.defaultProps = defaultProps;
Machine.contextTypes = contextTypes;

module.exports = Machine;



// WEBPACK FOOTER //
// ./js/components/frames/0-Intro/3-Machine.jsx